import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { skipToken } from '@reduxjs/toolkit/query';
import { useGetNaceCodeTreeQuery, useProfitCenterRecordQuery } from 'store/slices/dataSets/apis/dataSetsApi';
import { useGetLocationsCountriesQuery } from 'store/slices/geoLocations/apis/geoLocationsApi';
import { useUserMeQuery } from 'store/slices/user/apis/user';
import getProfitCentreDefaultValues from 'utils/formHelpers/getProfitCentreDefaultValues';
import { createProfitCentreSchema } from 'utils/validators';

import type { TCreateProfitCentreSchema } from 'utils/validators';
import type { ICreateProfitCentreForm } from '../interfaces/ICreateProfitCentreForm';

const useCreateProfitCentreForm = ({ recordId, isPageLoading }: ICreateProfitCentreForm) => {
  const fetchQuery = recordId ? {
    recordId,
  } : skipToken;

  const { data } = useProfitCenterRecordQuery(fetchQuery);
  const { data: userData } = useUserMeQuery();
  const { data: naceCodeTreeData } = useGetNaceCodeTreeQuery();
  const { data: locationsCountries } = useGetLocationsCountriesQuery();
  const companyCurrency = userData?.data?.company?.currency;

  const {
    control,
    handleSubmit,
    formState,
    formState: { isDirty, isLoading },
    reset,
    setError,
    getValues,
    setValue,
    watch,
  } = useForm<TCreateProfitCentreSchema>({
    mode: 'onSubmit',
    resolver: yupResolver(createProfitCentreSchema),
    values: isPageLoading ? undefined : getProfitCentreDefaultValues({
      values: data?.data,
      companyCurrency,
      naceCodeTreeData,
      locationsCountries: locationsCountries?.data || [],
    }),
  });

  const fieldsName = Object.keys(getValues());

  return {
    control,
    handleSubmit,
    isDirty,
    reset,
    isLoading,
    setError,
    fieldsName,
    watch,
    setValue,
    formState,
  };
};

export default useCreateProfitCentreForm;
